import React from 'react';
import FormEdit from '../../../components/common/Forms/FormEdit';

/**
 * DsgnFormEdit - Page wrapper for editing filled Design & Engineering forms
 * Used for navigation in routes/index.tsx
 */
const DsgnFormEdit: React.FC = () => {
  return <FormEdit />;
};

export default DsgnFormEdit;
